import { render } from "./air.svg?vue&type=template&id=52c495b4?inline"
const script = {}
script.render = render

export default script